export default "__VITE_ASSET__7ekVUtmJ__"